import React, { useEffect, useRef, useCallback } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import IconRightArrow from '../../IconRightArrow/IconRightArrow'
import IconX from '../../IconX/IconX'
import { getInsuranceLink } from '../../../domain/insurance/getInsuranceLink'

const Spring = ({
  isOpen,
  onClose,
  data,
  showInsuranceLink,
  centerLocations = []
}) => {
  const modalRef = useRef(null)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, onClose])

  const onClickClose = useCallback(() => {
    onClose()
  })

  const modalVariants = {
    hidden: {
      opacity: 0,
      y: '100%'
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        damping: 20,
        stiffness: 300
      }
    },
    exit: {
      opacity: 0,
      y: '100%',
      transition: {
        type: 'spring',
        damping: 20,
        stiffness: 300
      }
    }
  }
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 0.7 },
    exit: { opacity: 0 }
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="fixed inset-0 z-40 bg-[#16294180] opacity-0"
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          />
          <motion.div
            className="fixed inset-x-0 bottom-0 z-50 rounded-t-2xl bg-white p-6 shadow-xl"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            ref={modalRef}
          >
            <div className="flex justify-end">
              <button
                className="p-4 text-gray-800"
                onClick={onClickClose}
              >
                <IconX />
              </button>
            </div>
            <div className="mb-6 flex flex-col">
              <div className="mx-auto mb-4">
                <img
                  src={data.img}
                  className="size-[136px] object-contain"
                  alt="insurance-logo"
                />
              </div>
              <div className="text-gray-800">
                <p
                  className="text-base font-normal"
                  dangerouslySetInnerHTML={{
                    __html: data?.description
                  }}
                ></p>
              </div>
            </div>
            {showInsuranceLink && (
              <div>
                <a
                  className="flex h-[42px] items-center justify-center rounded-lg border border-gray-400 bg-white text-gray-800"
                  href={getInsuranceLink(
                    data.title,
                    centerLocations,
                    data.link
                  )}
                >
                  Top Rehabs Accepting this Provider
                  <span className="mb-3 ml-2.5 h-[7px] w-3">
                    <IconRightArrow />
                  </span>
                </a>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default Spring
